export const ArrowLeft = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.5 12.646L19.854 13L20.207 12.646L19.854 12.292L19.5 12.646ZM4.5 12.146C4.36739 12.146 4.24022 12.1987 4.14645 12.2924C4.05268 12.3862 4 12.5134 4 12.646C4 12.7786 4.05268 12.9058 4.14645 12.9996C4.24022 13.0933 4.36739 13.146 4.5 13.146L4.5 12.146ZM15.854 17L19.854 13L19.146 12.292L15.146 16.292L15.854 17ZM19.854 12.292L15.854 8.292L15.146 9L19.146 13L19.854 12.292ZM19.5 12.146L4.5 12.146L4.5 13.146L19.5 13.146L19.5 12.146Z"
      fill="black"
    />
  </svg>
);
